module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 8.063 11.15",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#arrow",
      toString: function () {
        return this.url;
      }
    }